import React from "react"

import {FieldGoalListEditableProps} from "../../../render/goal-list/goal-list-editable"
import FieldInlineEditable from "../../../render/inline-editable"

export default function FieldProto_GoalListEditable(props:FieldGoalListEditableProps) {
    return <FieldInlineEditable className   = {props.className}
                                field       = {props.field}
                                model       = {props.model}
                                onChange    = {props.onChange}/>
}
